import { render, staticRenderFns } from "./PendingLeaveApplicationWidget.vue?vue&type=template&id=05767cdf&"
import script from "./PendingLeaveApplicationWidget.vue?vue&type=script&lang=js&"
export * from "./PendingLeaveApplicationWidget.vue?vue&type=script&lang=js&"
import style0 from "./PendingLeaveApplicationWidget.vue?vue&type=style&index=0&id=05767cdf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports